import { createContext } from "react";

const friendContext = createContext();

export default friendContext;
